import { defineComponent as _defineComponent } from 'vue'
import {computed, onMounted, ref, watch,} from "vue";
import FilterMint from "./FilterMint.vue";
import SignalLinkModal from "../signals/SignalLinkModal.vue";
import {ISignal} from "@/shared";
import {useAutomationStore} from "@/pinia";

// props
interface IProps {
	value?: any;
	component: any;
	componentProps?: any;
	dataLabel: string;
	dataMessage?: string;
	// field: string;
	// type: string;
}

interface IEmits {
	(e: "input", input: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterLinkSignal',
  props: {
    value: null,
    component: null,
    componentProps: null,
    dataLabel: null,
    dataMessage: null
  },
  emits: ["input"],
  setup(__props: any, { expose, emit }: { emit: ({
	(e: "input", input: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	value?: any;
	component: any;
	componentProps?: any;
	dataLabel: string;
	dataMessage?: string;
	// field: string;
	// type: string;
};



// computed
const linked = computed<boolean>(() => {
	return signal.value !== null;
});
const isInvalid = computed<boolean>(() => {
	if (linked.value) return false;
	return componentRef.value?.isInvalid;
});
const getVariable = computed<string>(() => {
	return `{signals[${signal.value.id}].${field.value}}`;
});

// store
const automationStore = useAutomationStore();

// data
const signal = ref<ISignal | null>(null);
const input = ref<any>(props.value);
const field = ref<string>("");
const label = ref<string>("");
const componentRef = ref<InstanceType<typeof FilterMint> | null>(null);
const SignalLinkModalRef = ref<InstanceType<typeof SignalLinkModal> | null>(
	null
);

// methods
function mounted() {
	const res = automationStore.getSignalByVariable(props.value);

	if (!res) return;

	signal.value = res.signal;
	field.value = res.field;
	label.value = res.label;
}

function showSignalLink() {
	SignalLinkModalRef.value?.show();
}

function selectSignal({
												signal: s,
												field: f,
												label: l,
											}: {
	signal: ISignal;
	field: string;
	label: string;
}) {
	signal.value = s;
	field.value = f;
	label.value = l;
}

function resetSignal() {
	signal.value = null;
	field.value = "";
	label.value = "";
}

// setup
onMounted(mounted);

// watch
watch(
	() => input.value,
	() => {
		if (linked.value) return;

		emit("input", input.value);
	}
);
watch(
	() => linked.value,
	() => {
		if (linked.value) {
			emit("input", getVariable.value);
			return;
		}

		emit("input", input.value);
	}
);

// emits


// expose
expose({isInvalid});

return { __sfc: true,props, linked, isInvalid, getVariable, automationStore, signal, input, field, label, componentRef, SignalLinkModalRef, mounted, showSignalLink, selectSignal, resetSignal, emit, SignalLinkModal }
}

})